import { generateBarChart } from './charts/generateBarChart';
import { generateLineChart } from './charts/generateLineChart';

document.addEventListener('DOMContentLoaded', function () {
	// console.log('Custom charts loaded!!');
	let chartBlocks = document.querySelectorAll('.custom_chart');

	if (chartBlocks.length === 0) {
		// console.log('No chart blocks found');
		return;
	}

	chartBlocks.forEach(chartBlock => {
		let chartId = chartBlock.id;
		// console.log('Generating chart for block:', chartId);

		let chartData = JSON.parse(chartBlock.dataset?.chartData);

		if (!chartData) {
			console.log('No chart data found for block', chartBlock);
			return;
		}

		let chartWrapper = chartBlock.querySelector('canvas');

		if (!chartWrapper) {
			console.log('No chart wrapper found for block', chartBlock);
			return;
		}

		let chartSettings = JSON.parse(chartBlock.dataset?.settings);

		// console.log('All set to generate chart:', chartData);

		// TODO: Add support for other chart types
		switch (chartData.type) {
			case 'bar':
				generateBarChart(chartWrapper, chartData, chartSettings);
				break;

			case 'line':
				generateLineChart(chartWrapper, chartData, chartSettings);
				break;

			default:
				console.log('Unsupported chart type:', chartData.type);
		}
	});
});
